// 权限菜单接口 
import axios from 'axios'

// 管理员用户-删除用户
export function deleteUser(id) {
  return axios({
    url: `/api/ums/user/deleteUser?id=${id}`,
    method: 'get',
  })
}

// 管理员-授权菜单(menus,roleId)
export function empowerMenu(params) {
  return axios({
    url: `/api/ums/user/empowerMenu`,
    method: 'post',
    data: params
  })
}

// 管理员-授权角色(roleId,userId)
export function empowerRole(params) {
  return axios({
    url: `/api/ums/user/empowerRole`,
    method: 'post',
    data: params
  })
}

// 管理员-查询菜单列表
export function getMenuData() {
  return axios({
    url: `/api/ums/user/getMenuData`,
    method: 'get',
  })
}

// 管理员-查询角色菜单(roleId)
export function getRoleMenuData(roleId) {
  return axios({
    url: `/api/ums/user/getRoleMenuData?roleId=${roleId}`,
    method: 'get',
  })
}
// 管理员-查询用户角色(username)
export function getUserRoleData(username) {
  return axios({
    url: `/api/ums/user/getUserRoleData?username=${username}`,
    method: 'get',
  })
}
// 管理员-查询用户菜单(username)
export function getUserMenuData(username) {
  return axios({
    url: `/api/ums/user/getUserMenuData?username=${username}`,
    method: 'get',
  })
}
// 管理员-通过用户名查询用户(username)
export function loadUserByUserName(username, userType) {
  return axios({
    url: `api/ums/user/loadUserByUsername?username=${username}&userType=${userType}`,
    method: 'get',
  })
}

// 管理员-查询角色
export function getRolePage(data) {
  return axios({
    url: `/api/ums/user/getRolePage`,
    method: 'get',
    params: data
  })
}
// 管理员-查询角色不分页
export function getRoleList() {
  return axios({
    url: `/api/ums/user/getRole`,
    method: 'get',
  })
}

// 管理员-查询用户(分页)
export function getUserPage(data) {
  return axios({
    url: `/api/ums/user/getUserPage`,
    method: 'get',
    params: data
  })
}
// 管理员-查询用户(不分页)
export function getUser(data) {
  return axios({
    url: `/api/ums/user/getUser`,
    method: 'get',
    params: data
  })
}

// 管理员-新增角色
export function insertRole(data) {
  return axios({
    url: `/api/ums/user/insertRole`,
    method: 'post',
    data
  })
}

// 管理员-新增用户
export function insertUser(data) {
  return axios({
    url: `/api/ums/user/insertUser`,
    method: 'post',
    data
  })
}

// 管理端-修改密码password,username
export function updatePassword(data) {
  return axios({
    url: `/api/ums/user/updatePassword`,
    method: 'post',
    params: data
  })
}

// 管理员-修改角色
export function updateRole(data) {
  return axios({
    url: `/api/ums/user/updateRole`,
    method: 'post',
    data
  })
}

// 管理员-修改用户
export function updateUser(data) {
  return axios({
    url: `/api/ums/user/updateUser`,
    method: 'post',
    data
  })
}

